(() => {
  const header = document.getElementById('fw-sticky-header');
  if (header) {
    const resize = () => document.documentElement.style.setProperty('--fw-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(header);
  }
  const menu = document.querySelector('.fw-menu');
  if (menu) {
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  }
  document.querySelectorAll('.fw-nav a,.fw-menu nav a').forEach(link => {
    const url = new URL(link.href);
    if (!url.hash && url.pathname === location.pathname) link.setAttribute('aria-current', 'page');
  });
  document.querySelectorAll('[data-size-guide]').forEach(guide => {
    guide.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
      const unit = button.dataset.unit;
      guide.querySelectorAll('[data-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      guide.querySelectorAll('td[data-cm]').forEach(cell => { cell.textContent = `${cell.dataset[unit]} ${unit}`; });
    }));
  });
  const prose = document.querySelector('[data-page-prose]');
  const toc = document.querySelector('[data-page-toc]');
  if (prose && toc) {
    const headings = [...prose.querySelectorAll('h2')].filter(h => h.textContent.trim());
    if (headings.length > 1) {
      const list = toc.querySelector('ul');
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = `fw-topic-${i + 1}`;
        const item = document.createElement('li'), link = document.createElement('a');
        link.href = `#${heading.id}`; link.textContent = heading.textContent;
        link.addEventListener('click', () => { heading.tabIndex = -1; heading.focus({preventScroll:true}); });
        item.append(link); list.append(item);
      });
      toc.hidden = false;
      let scheduled = false;
      const highlight = () => {
        scheduled = false;
        const top = (header ? header.getBoundingClientRect().height : 0) + 80;
        let current = headings[0];
        headings.forEach(h => { if (h.getBoundingClientRect().top <= top) current = h; });
        list.querySelectorAll('a').forEach(link => {
          if (link.hash === `#${current.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(highlight); } }, {passive:true});
      highlight();
    }
  }
})();
